// extracted by mini-css-extract-plugin
export default {"link":"GK-z","disabled":"HK-z"};